import { ProfileEnum, profilesProperties } from "@utils/enums/profile.enum";
import { ProfileProperties } from "@type/core/auth/auth.types";

export function getProfilePropertiesFrom(
  profile: ProfileEnum,
): ProfileProperties {
  return profile && profilesProperties[profile];
}
